export type GuideNavId =
  | 'overview'
  | 'phantom'
  | 'solflare'
  | 'nightly'
  | 'backpack'
  | 'brave';

export interface GuideNavItem {
  id: GuideNavId;
  label: string;
  comingSoon?: boolean;
}

export const WALLET_GUIDE_NAV: GuideNavItem[] = [
  { id: 'overview', label: 'CWY Rewards & Token' },
  { id: 'phantom', label: 'Phantom' },
  { id: 'nightly', label: 'Nightly' },
  { id: 'solflare', label: 'Solflare' },
  { id: 'backpack', label: 'Backpack' },
  { id: 'brave', label: 'Brave Wallet' },
];
